import styled from 'styled-components';

export const StyledHomePage = styled.div`
  width: 100%;
`;
